import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormConfValidacaoForms from '../../components/forms/FormConfValidacaoForms'
import Body from '../../components/layouts/body';


class ConfValidacaoForm extends React.Component {
                
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Validação de Formulários" subtitulo="Cadastro" descricao="" />
            <Body>                
                <FormConfValidacaoForms  />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(ConfValidacaoForm));